export var DEFAULT_CONTAINER_CLASS_NAME = 'price-range';